import EastIcon from '@mui/icons-material/East';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Box, Container, Grid, IconButton, Stack, Tab, Tooltip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  // ESTADOS_CONTRATO_CHOICE,
  EstadosContratoChoiceEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  a11yProps,
  // a11yProps,
  gridSizeMdLg1,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  hasAllPermissions,
  useCheckPermissions,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
  useTabsFormOnly,
  // useTabsFormOnly,
} from '@/shared';
import { useFetchContratos } from '@/shared/actions/erp';
import {
  CustomAutocompleteArrString,
  CustomTabPanel,
  FormTabsOnly,
  // FormTabsOnly,
  GeneralTable,
  SingleIconButton,
  TabsFormBoxScene,
  // TabsFormBoxScene,
} from '@/shared/components/ui';
import { SAVE_CLIENTE_CONTRATO_PERMISSIONS } from '@/shared/constants/form-permissions';
import { Contrato, ESTADOS_INFO_CONTRATO_CHOICE, EstadosActualizacionContratoEnum } from '@/shared/interfaces';

import { ClientesFibraAprobados, ClientesFibraFiltersMotivos } from '@/erp/clientes/fibra-optica/pages';
import { useColumnsClientes } from '@/erp/clientes/fibra-optica/shared/hooks';
// import { useState } from 'react';
// import { ModalGenerarExcelContratos } from '../../../shared/components';
// import { CustomTabPanel } from '@/erp/sale';
// import ClientesFibraFiltersMotivos from './ClientesFibraFiltersMotivos';



export type ClientesFibraMainPageProps = {};

type FormDataClientes = {
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
};

const ClientesFibraMainPage: React.FC<ClientesFibraMainPageProps> = () => {
  const navigate = useNavigate();
  useCheckPermissions(PermissionsEnum.api_view_contrato);
  

  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.clientes.fibraOpticaNav;

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();


  const {
    // globalFilter,
    pagination,
    searchTerm,
    // onChangeFilter,
    setPagination,
    // cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const [openGenerateReport, setOpenGenerateReport] = useState(false);

  ///* form ---------------------------
  const form = useForm<FormDataClientes>({
    defaultValues: {
      estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
  });
  const { errors } = form.formState;

  const watchedContratoInfoState = form.watch('estadoInformacionContrato');

  ///* fetch data ---------------------------
  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,

      ...(watchedContratoInfoState !== EstadosActualizacionContratoEnum.ALL && {
        estado_actualizacion: 
          watchedContratoInfoState ==EstadosActualizacionContratoEnum.PENDIENTE_REVISION?
            "ACTUALIZADO"
          :watchedContratoInfoState ==EstadosActualizacionContratoEnum.APROBADO?
            "REVISADO"
          :watchedContratoInfoState,
      }),
      tipo_servicio: "RADIO",
      preventa_estado_aceptacion:true,
      estado_contrato_in: `${EstadosContratoChoiceEnum.ACTIVO},${EstadosContratoChoiceEnum.SUSPENDIDO}`,
      ...filterObject,
    },
  });

  ///* handlers ---------------------------
  const onEdit = (original: Contrato) => {
    navigate(`${clientesFibraOpticaReturnUrl}/ver/${original.id_contrato}`);
  };

  ///* columns ---------------------------
  const { clientesFibraColumns } = useColumnsClientes();

  ///* effects ---------------------------
  useLoaders(isLoadingContratos || isRefetchingContratos);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="xl">
        <Stack >
          {/* ========= title & create btn ========= */}
          {/* <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1} pb={2}>
              <Typography variant="h4">Clientes Wireless</Typography>
            </Stack>
          </Stack> */}

          <TabsFormBoxScene
            titlePage="Clientes Wireless" // only for typescript
            // titlePageNode={<ClienteFibraFormTitle contract={contract!} showRejectButton={true} />}
            // size={gridSizeMdLg10} // actual form container size
            showBtns={false}
            // // custom btns
            size={gridSizeMdLg12}
            showCustomBtns
            // // tabs
            tabs={
              <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
                <Tab label="TODOS LOS CONTRATOS" value={1} {...a11yProps(1)} />
                <Tab label="FILTROS" value={2} {...a11yProps(2)} />
                <Tab label="APROBADOS" value={3} {...a11yProps(3)} />
              </FormTabsOnly>
            }
          >
            {/* =================== Todos los registros =================== */}
            <CustomTabPanel index={valueTab} value={1}>
                <Grid item container {...gridSizeMdLg12}>
                  {/* <Grid container spacing={1}  direction={"row-reverse"}   {...gridSizeMdLg12}  sx={{marginY:1}}>
                    <Button
                      onClick={()=>setOpenGenerateReport(true)}
                      variant="outlined"
                      sx={{
                        py: 1,
                        my: 0,
                        marginX:1
                      }}
                      size="small"
                    >
                      Generar Reporte
                    </Button>
                  </Grid> */}

                  <Grid container spacing={1}  direction={"row"} {...gridSizeMdLg6}  sx={{marginY:1}}>
                    <CustomAutocompleteArrString
                      size={gridSizeMdLg10}
                      label="Estado Contrato"
                      name="estadoInformacionContrato"
                      control={form.control}
                      defaultValue={
                        form.getValues().estadoInformacionContrato ||
                        EstadosActualizacionContratoEnum.ALL
                      }
                      options={ESTADOS_INFO_CONTRATO_CHOICE}
                      isLoadingData={false}
                      error={errors.estadoInformacionContrato}
                      helperText={errors.estadoInformacionContrato?.message}
                      // size={gridSizeMdLg12}
                      disableClearable
                    />
                    {/* <div style={{ justifyContent: 'end', display: 'flex', backgroundColor:"rebeccapurple"}}> */}
                      <SingleIconButton
                        size={gridSizeMdLg1}
                        startIcon={<FilterAltOffIcon />}
                        onClick={() => {
                          form.setValue(
                            'estadoInformacionContrato',
                            EstadosActualizacionContratoEnum.ALL
                          );
                        }}
                      />
                    {/* </div> */}
                  </Grid>

                  {/* <Grid container spacing={1}  direction={"row"} {...gridSizeMdLg6} item sx={{marginY:1}}>
                    <CustomAutocompleteArrString
                      label="Estado Servicio"
                      name="contratoState"
                      control={form.control}
                      defaultValue={
                        form.getValues().contratoState ||
                        EstadosContratoChoiceEnum.ALL
                      }
                      options={ESTADOS_CONTRATO_CHOICE.filter(
                        estado => estado !== EstadosContratoChoiceEnum.EN_ESPERA
                      )}
                      isLoadingData={false}
                      error={errors.contratoState}
                      helperText={errors.contratoState?.message}
                      size={gridSizeMdLg10}
                      disableClearable
                    />
                    
                      <SingleIconButton
                        size={gridSizeMdLg1}
                        startIcon={<FilterAltOffIcon />}
                        onClick={() => {
                          form.setValue(
                            'contratoState',
                            EstadosContratoChoiceEnum.ALL
                          );
                        }}
                      />
                    
                  </Grid> */}
                  <GeneralTable<Contrato>
                    columns={clientesFibraColumns}
                    data={contratosPagingRes?.data?.data || []}
                    //
                    isLoading={isLoadingContratos}
                    isRefetching={isRefetchingContratos}
                    // // filters - server side
                    enableManualFiltering={true}
                    columnFilters={columnFilters}
                    onColumnFiltersChange={setColumnFilters}
                    // // search
                    enableGlobalFilter={false}
                    // // pagination
                    pagination={pagination}
                    onPaging={setPagination}
                    rowCount={contratosPagingRes?.data?.count}
                    // // actions ========
                    enableColumnActions={hasAllPermissions([
                      ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
                      PermissionsEnum.api_change_contrato,
                    ])}
                    enableEditing={hasAllPermissions([
                      ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
                      PermissionsEnum.api_change_contrato,
                    ])}
                    actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
                    // crud
                    canEdit={hasAllPermissions([
                      ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
                      PermissionsEnum.api_change_contrato,
                    ])}
                    // onEdit={onEdit}
                    onCustomEdit={(r)=>
                      r.estado_contrato==EstadosContratoChoiceEnum.CANCELADO?"":
                      <Tooltip title={"Ir a detalle"} placement='top'>
                        <IconButton
                          onClick={() => {
                            onEdit(r!);
                          }}
                        >
                          <EastIcon />
                        </IconButton>
                      </Tooltip>
                    }
                    // editIcon={<EastIcon />}
                    toolTipTitleEditIcon="Ir a detalle"
                    canDelete={false}
                  />
                </Grid>
            </CustomTabPanel>


            {/* =================== Reporte con mas filtros =================== */}
            <CustomTabPanel index={valueTab} value={2}>
              <ClientesFibraFiltersMotivos tipoServicio='RADIO'/>
            </CustomTabPanel>
          </TabsFormBoxScene>

          {/* =================== Reporte Clientes Aprobados =================== */}
          <CustomTabPanel index={valueTab} value={3}>
            <ClientesFibraAprobados tipoServicio='RADIO'/>
          </CustomTabPanel>


          {/* ========= Search & Table ========= */}
          {/* <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            cleanFilter={cleanFilter}
            text="por identificación del cliente"
            showCustomBox
            customBox={
              
            }
          /> */}
          
        </Stack>
        {/* {
          openGenerateReport?
            <ModalGenerarExcelContratos
              open={openGenerateReport}
              setOpen={setOpenGenerateReport}
            />
          :null
        } */}
      </Container>
    </Box>
  );
};

export default ClientesFibraMainPage;
